<template>
  <form @submit.prevent="createFee()" action="">
    <ion-row>
      <ion-col size="12">
        <ion-list>
          <ion-item v-if="validationError" lines="none">
            <ion-label className="ion-text-wrap">
              <ion-text color="danger">
                <p v-for="error of v$.$errors" :key="error.$uid">
                  <ion-icon
                    :ios="alertCircleOutline"
                    :md="alertCircleSharp"
                    size="small"
                    style="vertical-align: middle"
                  ></ion-icon
                  >{{ error.$property }}: {{ error.$message }}
                </p></ion-text
              >
            </ion-label>
          </ion-item>

          <ion-item :class="{ 'color-danger': v$.standard_id.$error }">
            <ion-label position="floating">Standard</ion-label>
            <ion-select v-model="standard_id" @ionChange="fetchStudents()">
              <ion-select-option
                v-for="standard of standards"
                :key="standard.id"
                :value="standard.id"
              >
                Standard {{ standard.name }}
              </ion-select-option>
            </ion-select>
          </ion-item>

          <ion-item :class="{ 'color-danger': v$.student_ids.$error }">
            <ion-label position="floating">Students</ion-label>
            <ion-select
              v-model="student_ids"
              multiple
              :disabled="disable_student_selection"
              :interface-options="{ cssClass: 'full-screen' }"
            >
              <ion-select-option
                v-for="student of students"
                :key="student.id"
                :value="student.id"
              >
                {{
                  `${student.section_standard.section.name}-${student.roll_no} ${student.user.user_detail.name}`
                }}
              </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-button type="submit" expand="full" class="ion-margin-vertical">
          Save
        </ion-button>
      </ion-col>
    </ion-row>
  </form>
</template>

<script>
import {
  IonRow,
  IonCol,
  IonList,
  IonLabel,
  IonItem,
  IonIcon,
  IonButton,
  IonSelect,
  IonSelectOption,
  IonText,
  loadingController,
  alertController,
} from "@ionic/vue";

import { alertCircleOutline, alertCircleSharp } from "ionicons/icons";

import { required, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default {
  props: ["chargeable_id"],
  emits: ["closeModal"],

  components: {
    IonRow,
    IonCol,
    IonList,
    IonLabel,
    IonItem,
    IonIcon,
    IonButton,
    IonSelect,
    IonSelectOption,
    IonText,
  },
  data() {
    return {
      disable_student_selection: true,
      standard_id: null,
      student_ids: null,

      alertCircleOutline,
      alertCircleSharp,

      validationError: null,
      xhrError: {
        header: null,
        description: null,
      },
    };
  },

  computed: {
    standards() {
      return this.$store.getters["standard/allResources"];
    },

    students() {
      return this.$store.getters["chargeableStudent/studentsByStandard"];
    },
  },

  setup() {
    return { v$: useVuelidate() };
  },

  validations() {
    return {
      standard_id: {
        required: helpers.withMessage("is required", required),
      },
      student_ids: {
        required: helpers.withMessage("is required", required),
      },
    };
  },

  methods: {
    setModalState(state) {
      this.modalState = state;
    },

    loader(message) {
      const loading = loadingController.create({
        message: message,
        backdropDismiss: false,
      });

      return loading;
    },

    alerter(header, message, buttons = ["close"]) {
      const alert = alertController.create({
        header: header,
        message: message,
        buttons: buttons,
      });

      return alert;
    },

    setErrorResponse(error) {
      if (error.response) {
        this.xhrError.header = error.response.data.header;
        this.xhrError.message = error.response.data.message;
      } else if (error.request) {
        this.xhrError.header = error.message || error.request;
        this.xhrError.message = "Please check your connection and try again";
      } else {
        this.xhrError.header = error.message;
        this.xhrError.message = "Something went wrong. Try again later";
      }
    },

    async createFee() {
      this.v$.$touch();
      if (this.v$.$error) {
        this.validationError = true;
        return;
      }

      let data = {
        name: this.name,
        chargeable_id: this.chargeable_id,
        student_ids: this.student_ids,
      };

      const spinner = await this.loader("Saving...");
      spinner.present();

      try {
        await this.$store.dispatch("chargeableStudent/createResource", data);
        spinner.dismiss();

        this.name = null;
        this.$emit("closeModal");
      } catch (error) {
        spinner.dismiss();

        this.setErrorResponse(error);

        const alertDialog = await this.alerter(
          this.xhrError.header,
          this.xhrError.message
        );

        alertDialog.present();

        this.password = null;
        this.validationError = null;
      }
    },
    async fetchStandards() {
      await this.$store.dispatch("standard/allResources");
    },

    async fetchStudents() {
      const standard_id = this.standard_id;
      this.disable_student_selection = true;
      await this.$store.dispatch(
        "chargeableStudent/studentsByStandard",
        standard_id
      );
      this.disable_student_selection = false;
    },
  },

  created() {
    this.fetchStandards();
  },
};
</script>